import { createAction } from 'redux-act';

export const getNotifications = createAction('Get notifications');
export const getMockNotifications = createAction('Get mock notifications');

export const notificationsReceived = createAction('Notifications received');
export const notificationsReset = createAction('Reset notifications');
